import React from 'react'
import { withStyles, List, ListItem, ListItemText } from '@material-ui/core'

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
})

function SimpleList(props) {
  const { classes, plans } = props
  return (
    <div className={classes.root}>
      <List component="nav">
        {
          plans.map(plan => {
            const { name, planId } = plan
            return (
              <ListItem key={planId} button>
                <ListItemText primary={name} />
              </ListItem>
            )
          })
        }
      </List>
    </div>
  )
}

export default withStyles(styles)(SimpleList)


// WEBPACK FOOTER //
// ./src/components/Plan/List.jsx